import styled from "styled-components";
import { FaLinkedinIn } from "react-icons/fa";

const Section = styled.section`
  padding: 10px 20px;
  background: #f5f7fa;
  text-align: center;
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
    padding: 8px 2px;
    scroll-margin-top: 80px;
  }
`;

const Title = styled.h2`
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 40px;
  color: #791e1b;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 4px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 1200px;
  margin: auto;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const Card = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  position: relative;
  transition: 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;

const LinkedIn = styled.a`
  position: absolute;
  right: 18px;
  top: 18px;
  color: #0a66c2;
  font-size: 18px;
`;

const Img = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 6px;
`;

const Name = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #0f172a;
`;

const Role = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  margin-bottom: 6px;
`;

const Company = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #d6a54f;
`;

const speakers = [
  {
    name: "Mr. Amit Nabira",
    rolecompany: "Deputy General Manager/HOD, Mazagon Dock Shipbuilders",
    img: require("../assets/images/featured-speakers/AmitNabira.webp"),
    linkedin: "https://www.linkedin.com/in/amit-nabira-maheshwari-14454515/",
  },
  {
    name: "Ms. Anupama Shetty",
    rolecompany: "Mission Director - Biocon Foundation",
    img: require("../assets/images/featured-speakers/AnupamaShetty.webp"),
    linkedin: "https://www.linkedin.com/in/dr-anupama-shetty-0447b011/",
  },
  {
    name: "Mr. Devang Pandya",
    rolecompany: "VP & Lead CSR & Sustainability, Tata AIG General Insurance",
    img: require("../assets/images/featured-speakers/DevangPandya.webp"),
    linkedin: "https://www.linkedin.com/in/devang-pandya-a3834661/",
  },
  {
    name: "Mr. Narendra Kumar",
    rolecompany:
      "Executive Vice President Human Resources & Head CSR, Cholamandalam Investment & Finance Company",
    img: require("../assets/images/featured-speakers/NarendraKumar.webp"),
    linkedin: "https://www.linkedin.com/in/narendra-kumar-9a986a2/",
  },
  {
    name: "Ms. Rema Mohan",
    rolecompany: "CEO, NSE Foundation",
    img: require("../assets/images/featured-speakers/RemaMohan.webp"),
    linkedin: "https://www.linkedin.com/in/rema-mohan-6231972a/",
  },
  {
    name: "Mr. Rohit Kumar Agrawala",
    rolecompany: "Director - Finance, CPCL",
    img: require("../assets/images/featured-speakers/Mr-RohitKumarAgrawala.webp"),
    linkedin: "https://www.linkedin.com/in/rohit-kumar-agrawala-751266118/",
  },
  {
    name: "Mr. Sridhar NE",
    rolecompany: "CSO, Titan",
    img: require("../assets/images/featured-speakers/SridharNE.webp"),
    linkedin: "https://www.linkedin.com/in/sridhar-n-e-62217215/",
  },
  {
    name: "Ms. Pritha Venkatachalam",
    rolecompany:
      "Partner, India Head, and Co-Head, Asia and Africa - The Bridgespan Group",
    img: require("../assets/images/featured-speakers/prithavenkatachalam.webp"),
    linkedin: "https://www.linkedin.com/in/pritha-venkatachalam-a8a69ab0/",
  },
  {
    name: "Mr. Anil Parab",
    rolecompany: "Whole-Time Director & Sr. EVP, L&T India",
    img: require("../assets/images/featured-speakers/Anilprab.webp"),
    linkedin: "https://www.linkedin.com/in/anil-parab-03997516/",
  },
  {
    name: "Mr. Ganapathi Ramachandran",
    rolecompany: "Chairman, Trigyn Technologies",
    img: require("../assets/images/featured-speakers/Ganapathiramachandran.webp"),
    linkedin: "https://www.linkedin.com/in/ganapathi-ramachandran-8b9a3b1b0/",
  },
  {
    name: "Ms. Geetha Ramamoorthi",
    rolecompany: "VP & MD , KBR Inc.",
    img: require("../assets/images/featured-speakers/Geetharamamoorthi.webp"),
    linkedin: "https://www.linkedin.com/in/geetha-ramamoorthi-3b068a/",
  },
  {
    name: "Mr. Narayan P.S",
    rolecompany:
      "Global Head  of Sustainability at Wipro Ltd. and the Managing Trustee at Wipro Foundation, the Societal Initiatives arm of Wipro",
    img: require("../assets/images/featured-speakers/NarayanPS.webp"),
    linkedin: "https://www.linkedin.com/in/psnarayan5565/",
  },
  {
    name: "Mr. Naveen Unni",
    rolecompany: "Managing Partner, TVS Capital Fund",
    img: require("../assets/images/featured-speakers/Naveenunni.webp"),
    linkedin: "https://www.linkedin.com/in/naveen-unni/",
  },
  {
    name: "Mr. Sridhar Sidhu",
    rolecompany:
      "CVP, Cybersecurity, AT&T Communication Services India Pvt Ltd",
    img: require("../assets/images/featured-speakers/Sridharsidhu.webp"),
    linkedin: "https://www.linkedin.com/in/sridharsidhu/",
  },
  {
    name: "Mr. Prashant Nair",
    rolecompany: "Executive Editor, CNBC - TV18",
    img: require("../assets/images/featured-speakers/MPrashantNair.webp"),
    linkedin: "https://www.linkedin.com/in/prashant-nair-b6347221/",
  },
  {
    name: "Ms. Anupam Nidhi",
    rolecompany: "Head CSR, Vedanta Group & Hindustan Zinc ",
    img: require("../assets/images/featured-speakers/Anupamnidhi.webp"),
    linkedin: "https://www.linkedin.com/in/anupam-nidhi-55630a39/",
  },
  {
    name: "Mr. Anurag Pratap",
    rolecompany: "VP, CSR Leader, Digital Inclusion and Sustainability Leader, Capgemini Technology Services India Limited",
    img: require("../assets/images/featured-speakers/Anuragpratab.webp"),
    linkedin: "https://www.linkedin.com/in/anuragpratap/",
  },
  {
    name: "Mr. AS Prasad",
    rolecompany: "Vice President, Vertiv Energy Private Ltd India",
    img: require("../assets/images/featured-speakers/ASPrasad.webp"),
    linkedin: "https://www.linkedin.com/in/as-prasad-409b6610/",
  },
  {
    name: "Ms. Chetna Sharma",
    rolecompany: "Head and VP - Sustainability & New Initiatives, Indus Towers; Chairperson, Green Eenergy Committee",
    img: require("../assets/images/featured-speakers/Chetnasharma.webp"),
    linkedin: "https://www.linkedin.com/in/chetna-sharma-a044956/",
  },
  {
    name: "Mr. Gopal Kumar",
    rolecompany: "Head- CSR, Aditya Birla Capital Limited",
    img: require("../assets/images/featured-speakers/GopalKumar.webp"),
    linkedin: "https://www.linkedin.com/in/gopal-kumar-266a9319/",
  },
  {
    name: "Mr. Prabhakant Jain",
    rolecompany: "General Manager and Head - CSR, DS Group",
    img: require("../assets/images/featured-speakers/Prabhakantjain.webp"),
    linkedin: "https://www.linkedin.com/in/prabhakant-jain-2bb66018/",
  },
  {
    name: "Mr. Rajesh Das",
    rolecompany: "Head of CSR, Vardhaman Textiles",
    img: require("../assets/images/featured-speakers/Rajeshdas.webp"),
    linkedin: "https://www.linkedin.com/in/rajeshcsr/",
  },
  {
    name: "Mr. Sathisha CH",
    rolecompany:
      "Sr. Engineering Manager, Mechancal Systems Engineering, GE Aerospace",
    img: require("../assets/images/featured-speakers/Sathishch.webp"),
    linkedin: "https://www.linkedin.com/in/sathisha-ch/",
  },
  {
    name: "Mr. Nikhil Pant",
    rolecompany: "CEO & Chairman - REACHA; Founder & Partner, Lakshyaa",
    img: require("../assets/images/featured-speakers/Nikhilpant.webp"),
    linkedin: "https://www.linkedin.com/in/nikhilpant/",
  },
  {
    name: "Mr. Bhaskar Bhat",
    rolecompany: "Former Managing Director, Titan Company Limited",
    img: require("../assets/images/featured-speakers/BhaskarBhatt.webp"),
    linkedin: "https://www.linkedin.com/in/bhaskar-bhatt-a1681618/",
  },
  {
    name: "Mr. M.A. Siddique I.A.S.",
    rolecompany: "Managing Director, Chennai Metro Rail Ltd",
    img: require("../assets/images/featured-speakers/MASiddiqueIAS.webp"),
    linkedin: "https://www.linkedin.com/in/siddique-m-a-158068322/",
  },
  {
    name: "Mr. Chakrapani R.V.",
    rolecompany: "Founder, Aarvee Associates",
    img: require("../assets/images/featured-speakers/ChakrapaniRV.webp"),
    linkedin: "https://www.linkedin.com/in/chakrapani-r-v-04621014/",
  },
  {
    name: "Mr. H. Shankar",
    rolecompany: "Managing Director, CPCL",
    img: require("../assets/images/featured-speakers/HShankar.webp"),
    linkedin: "https://www.linkedin.com/in/shankar-h-787559352/",
  },
];

export default function FeaturedSpeakers() {
  return (
    <Section id="featured-speakers">
      <Title>Featured Speakers from Previous Summit</Title>

      <Grid>
        {speakers.map((sp, i) => (
          <Card key={i}>
            <LinkedIn href={sp.linkedin} target="_blank">
              <FaLinkedinIn />
            </LinkedIn>

            <Img src={sp.img} alt={sp.name} />
            <Name>{sp.name}</Name>
            <Role>{sp.rolecompany}</Role>
            {/* <Company>{sp.company}</Company> */}
          </Card>
        ))}
      </Grid>
    </Section>
  );
}
